import './App.css';
import React, { useState } from "react";
import axios from "axios";

export default function App() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setResult(null);
  };

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      const response = await axios.post("http://localhost:8000/upload/", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setResult(response.data);
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Something went wrong while uploading the file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6 flex flex-col items-center justify-center">
      <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4 text-center">Renovation AI Assistant</h1>

        <input
          type="file"
          accept=".ply"
          onChange={handleFileChange}
          className="w-full mb-4 border border-gray-300 rounded px-3 py-2"
        />

        <button
          onClick={handleUpload}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
        >
          {loading ? "Processing..." : "Upload Scan"}
        </button>

        {result && (
          <div className="mt-6 text-sm text-gray-800">
            <h2 className="text-lg font-semibold mb-2">Estimates:</h2>
            <p><strong>Floor Area:</strong> {result.floor_area_sqm} m²</p>
            <p><strong>Wall Area:</strong> {result.wall_area_sqm} m²</p>
            <div className="mt-2">
              <h3 className="font-semibold">Material Takeoff:</h3>
              <ul className="list-disc list-inside">
                <li>Flooring: ${result.material_takeoff.flooring}</li>
                <li>Drywall: ${result.material_takeoff.drywall}</li>
                <li>Paint: ${result.material_takeoff.paint}</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}